import React from 'react';

const ManufacturersSection = () => {
  const manufacturers = [
    {
      name: 'Bombardier',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/42/Bombardier_logo.svg/320px-Bombardier_logo.svg.png'
    },
    {
      name: 'Gulfstream',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Gulfstream_Aerospace_logo.svg/320px-Gulfstream_Aerospace_logo.svg.png'
    },
    {
      name: 'Embraer',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8f/Embraer_logo.svg/320px-Embraer_logo.svg.png'
    },
    {
      name: 'Airbus',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Airbus_logo_2017.svg/320px-Airbus_logo_2017.svg.png'
    },
    {
      name: 'Boeing',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Boeing_full_logo.svg/320px-Boeing_full_logo.svg.png'
    },
    {
      name: 'Cessna',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/Cessna_Logo.svg/320px-Cessna_Logo.svg.png'
    }
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16 space-y-3 sm:space-y-4">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#d4af37] uppercase tracking-wide">
            AIRCRAFT MANUFACTURERS WE SUPPORT
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
            We provide comprehensive support for all major aircraft manufacturers
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-6 sm:gap-8 items-center">
          {manufacturers.map((manufacturer, index) => (
            <div 
              key={index}
              className="group bg-white p-6 sm:p-8 rounded-xl shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-gray-100 hover:border-[#d4af37]/30 flex items-center justify-center min-h-[120px] sm:min-h-[140px]"
            >
              <div className="relative w-full h-16 sm:h-20 flex items-center justify-center">
                <img 
                  src={manufacturer.logo}
                  alt={`${manufacturer.name} logo`}
                  className="max-w-full max-h-full object-contain grayscale group-hover:grayscale-0 transition-all duration-500 opacity-60 group-hover:opacity-100"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'block';
                  }}
                />
                <div className="hidden text-center">
                  <h3 className="text-lg sm:text-xl font-bold text-[#0a1628] group-hover:text-[#d4af37] transition-colors duration-300">
                    {manufacturer.name}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 sm:mt-16 text-center">
          <p className="text-base sm:text-lg text-gray-600 font-medium">
            Serving customers in <span className="text-[#d4af37] font-bold">100+</span> countries worldwide
          </p>
        </div>
      </div>
    </section>
  );
};

export default ManufacturersSection;
